import {
  CardActionArea as MUICardActionArea,
  type CardActionAreaProps as MUICardActionAreaProps,
} from '@mui/material'
import { forwardRef } from 'react'
import type { LinkProps } from 'react-router-dom'
import { Link } from '@/helpers/Link'

//	///////////////////////
//	MARK: TYPES
export type TCardActionAreaLinkProps = MUICardActionAreaProps & LinkProps

//	///////////////////////
//	MARK: EXPORTS
export const CardActionAreaLink = forwardRef<HTMLAnchorElement, TCardActionAreaLinkProps>(
  (props, ref) => <MUICardActionArea component={Link} ref={ref} {...props} />,
)
